<template>
  <div class="HearingTest">
    <div class="HearingTest-test" >
        <v-container  grid-list-md pa-0 pb-3 class="HearingTest-test--sections">
          <v-layout raw wrap>
            <v-flex md3 sm3 xs6 >
              <div class="HearingTest-test--section" v-bind:class="{ Active: currentStep == 'Questions'}">
              <div class="HearingTest-test--sectionText">
                <span>1. </span>{{ Questions }}
              </div>
              <div class="HearingTest-test--partDots">
                <div v-for="dot in dotCount" class="pull-left" >
                  <div class="HearingTest-test--partDot"  v-bind:class="{ Active: currentDot == dot}"></div>
                </div>
              </div>
            </div>
            </v-flex>

            <v-flex md3 sm3 xs6  >
              <div class="HearingTest-test--section" v-bind:class="{ Active: currentStep == 'Calibration'}">
              <div class="HearingTest-test--sectionText">
                <span>2. </span>{{ Calibration }}</div>
                <div class="HearingTest-test--partDots">
                  <div v-for="dot in dotCount" class="pull-left" >
                    <div class="HearingTest-test--partDot"  v-bind:class="{ Active: currentDot == dot}"></div>
                  </div>
                </div>
            </div>
            </v-flex>

            <v-flex  md3 sm3 xs6  >
              <div class="HearingTest-test--section" v-bind:class="{ Active: currentStep == 'Pure_tone_test'}">
              <div class="HearingTest-test--sectionText">
                <span>3. </span>{{ Pure_tone_test }}</div>
                <div class="HearingTest-test--partDots">
                  <div v-for="dot in dotCount" class="pull-left" >
                    <div class="HearingTest-test--partDot"  v-bind:class="{ Active: currentDot == dot}"></div>
                  </div>
                </div>
            </div>
            </v-flex>

            <v-flex  md3 sm3 xs6  >
          <div class="HearingTest-test--section" v-bind:class="{ Active: currentStep == 'Speech_test'}">
          <div class="HearingTest-test--sectionText">
            <span>4. </span>
            {{ Speech_test }}</div>
            <div class="HearingTest-test--partDots">
              <div v-for="dot in dotCount" class="pull-left" >
                <div class="HearingTest-test--partDot"  v-bind:class="{ Active: currentDot == dot}"></div>
              </div>
            </div>
        </div>
        </v-flex>
          </v-layout>
        </v-container>
    </div>
  </div>
  <!-- navbar-1.vue -->
</template>

<script>
export default {
    name:'HearingSteps',
    props: [
        'currentStep',
        'dotCount',
        'currentDot'
    ],
    mounted() {

    },
    data () {

      return {
          Questions: 'سوالات',
          Calibration: 'کالیبراسیون',
          Pure_tone_test: 'تست تن',
          Speech_test: 'تست گفتار',
      }
    }
}
</script>

<style scoped>
  .pull-left{
    float: right;
  }
  .HearingTest .HearingTest-test {
    margin: 0;
    text-align: center;
    padding: 20px 15px;
  }

  .HearingTest .HearingTest-test .HearingTest-test--sections {
    padding-bottom: 12px;
    border-bottom: 2px dotted #999;
    width: 100%;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section {

    min-height: 42px;
    margin-bottom: 4px;
    padding: 7px 10px 5px;
    background-color: #ced0d0;
    color: #000;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section .HearingTest-test--sectionText {
    font-weight: normal;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section.Active {
    background-color: #78cfdd;
    color: #fff;

    text-align: center;
  }

  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section .HearingTest-test--partDots {

    display: inline-block;
    margin: 0 auto;
  }

  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section .HearingTest-test--partDots .HearingTest-test--partDot {
    width: 5px;
    height: 5px;
    margin: 0 1px;
    border: 1px solid #b3b3b3;
    background-color: #dcddde;
    border-radius: 5px;
    float: left;
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }

  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section .HearingTest-test--partDot {
    display: none;
    border: 1px solid #60a6b3;
    background-color: #70c0ce;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section.Active .HearingTest-test--partDot {
    display: inline-block;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section.Active .HearingTest-test--partDot.Active {
    border-color: #60a6b3;
    background-color: #2b868f;
  }
  .HearingTest .HearingTest-test .HearingTest-test--sections .HearingTest-test--section.Active .HearingTest-test--partDot {
    border-color: #60a6b3;
    background-color: #70c0ce;
  }

</style>



// WEBPACK FOOTER //
// src/components/HearingTest/steps.vue